import { createFileRoute } from "@tanstack/react-router";
import { PartnerShell } from "../../../features/partner/components/partner-shell";
import { PartnerDatePage } from "../../../features/partner/pages/partner-date-page";

/** `/{lang}/partner/trips/{activityId}/dates/{date}`: the guest list of one date. */
export const Route = createFileRoute("/$lang/_partner/partner/trips/$activityId/dates/$date")({
  component: PartnerDateRoute,
});

function PartnerDateRoute() {
  const { lang, activityId, date } = Route.useParams();
  const search = Route.useSearch();
  return (
    <PartnerShell lang={lang} search={search} tab="trips">
      <PartnerDatePage activityId={activityId} date={date} />
    </PartnerShell>
  );
}
